var render = function (_h,_vm) {var _c=_vm._c;return _c('BaseModal',_vm._g(_vm._b({class:['about', 'is-yellow'],attrs:{"name":"about"}},'BaseModal',_vm.props,false),_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }